import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function GetCourts() {
  return client.post("Classifiers/GetCourts", prepareRequest({}));
}

function GetCourtExecutors() {
  return client.post("Classifiers/GetCourtExecutors", prepareRequest({}));
}

function GetExpenseReasons() {
  return client.post("Classifiers/GetExpenseReasons", prepareRequest({}));
}

function GetCompanyRequisitesByType(type) {
  return client.post("Classifiers/GetCompanyRequisitesByType", prepareRequest({ Type: type }));
}

function GetMessageTemplates() {
  return client.post("Classifiers/GetMessageTemplates", prepareRequest({}));
}

export {
  GetCourts,
  GetCourtExecutors,
  GetExpenseReasons,
  GetCompanyRequisitesByType,
  GetMessageTemplates,
};
